import { VALIDATE_REFERRAL_SUCCESS } from '../actions';

const initialState = {
    referral: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case VALIDATE_REFERRAL_SUCCESS:
            return {
                ...state,
                referral: action.payload.data,
            };
        default:
            return state;
    }
}

export default app;
